import { useContext } from 'react';
import TrackWrapper from '@/common/TrackWrapper';
import formatEvent from '@/home/utils/formatEvent';
import Sections from '~/constants/home/sections';
import TradeContext, {
  useGetTradeInStatus
} from '~/context/common/TradeContext';
import FinanceContext, {
  useHasExpiredSoftpull,
  useHasValidSoftPull
} from '~/context/home/FinanceContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import DynamicPromoTile from './DynamicPromoTile/DynamicPromoTile';
import { PromoTileWrapper } from './PromoTile.styles';
import { TileType } from './TileUtils';

const financeTradePromoAttributes = {
  description: 'Dual promo tile',
  content: ['Finance', 'Trade']
};

const financeTradePromoViewEvent = formatEvent(
  'Viewed - Home feed section',
  financeTradePromoAttributes
);

function FinanceTradePromoTiles({ isNewUser }) {
  const { trades } = useContext(TradeContext);
  const { financeInfo } = useContext(FinanceContext);

  const hasValidSoftpull = useHasValidSoftPull();
  const hasExpiredSoftpull = useHasExpiredSoftpull();
  const tradeInStatus = useGetTradeInStatus();

  return (
    <TrackWrapper event={financeTradePromoViewEvent}>
      <PromoTileWrapper>
        <DynamicPromoTile
          tileType={TileType.Finance}
          isActive={hasValidSoftpull}
          isExpired={hasExpiredSoftpull}
          isLoaded={financeInfo.isLoaded}
          isNewUser={isNewUser}
        />
        <DynamicPromoTile
          tileType={TileType.Trade}
          isActive={tradeInStatus.isActive}
          isExpired={tradeInStatus.isExpired}
          isLoaded={trades.isLoaded}
          isPending={tradeInStatus.isPending}
          isNewUser={isNewUser}
        />
      </PromoTileWrapper>
    </TrackWrapper>
  );
}

export default withErrorBoundary(
  FinanceTradePromoTiles,
  undefined,
  undefined,
  Sections.FinanceTradePromoTiles
);
